import Form, { type FormInstance } from 'antd/es/form';
import Input from 'antd/es/input';
import Typography from 'antd/es/typography';
import React from 'react';
import { styled, useTheme } from 'styled-components';

import type { AgentFormData } from '../../AgentModals/CreateAgentModal';

const { Title, Paragraph } = Typography;
const { TextArea } = Input;

const FormContainer = styled.div`
  ${({ theme }) => `
  padding: 0 ${theme.paddingContentHorizontal}px;
  margin: 0 auto;
`}
`;

interface AgentBasicsFormProps {
  form: FormInstance<AgentFormData>;
}

export const AgentBasicsForm: React.FC<AgentBasicsFormProps> = () => {
  const theme = useTheme();
  return (
    <FormContainer>
      <Title level={4} style={{ marginBottom: `${theme.marginXS}px` }}>
        Basic Information
      </Title>
      <Paragraph
        type="secondary"
        style={{ marginBottom: `${theme.marginLG}px` }}
      >
        Give your agent a name and description to help identify its purpose.
      </Paragraph>

      <Form.Item
        name="name"
        label="Agent Name"
        rules={[
          { required: true, message: 'Please enter an agent name' },
          { min: 1, message: 'Name must be at least 1 character' },
          { max: 255, message: 'Name cannot exceed 255 characters' },
        ]}
      >
        <Input
          placeholder="e.g., Research Assistant, Data Analyzer"
          size="large"
          autoFocus
        />
      </Form.Item>

      <Form.Item
        name="description"
        label="Description"
        help="Optional - describe what this agent does"
      >
        <TextArea
          placeholder="e.g., Helps analyze documents and answer questions based on their content"
          rows={3}
          maxLength={1000}
          showCount
        />
      </Form.Item>
    </FormContainer>
  );
};
